"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountNewProject = exports.NewProjectController = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var NewProject_1 = require("./NewProject");
var HubspotNewProjectTypes_1 = require("./HubspotNewProjectTypes");
var Types_1 = require("@CommonFrontendBackend/Hubspot/Types");
var mobx_1 = require("mobx");
var ContactSelection_1 = require("../ContactSelection/ContactSelection");
var ContactSelectionTypes_1 = require("Hubspot/ContactSelection/ContactSelectionTypes");
var NewProjectApiService_1 = require("./NewProjectApiService");
var CloningState;
(function (CloningState) {
    CloningState[CloningState["NotCloning"] = 0] = "NotCloning";
    CloningState[CloningState["IsCloning"] = 1] = "IsCloning";
    CloningState[CloningState["FinishedCloning"] = 2] = "FinishedCloning";
})(CloningState || (CloningState = {}));
var NewProjectController = (function (_super) {
    __extends(NewProjectController, _super);
    function NewProjectController(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = [];
        _this.filteredTemplates = [];
        _this.selectedTemplate = null;
        _this.isFailed = false;
        _this.shouldReconnect = false;
        _this.currentCloningState = CloningState.NotCloning;
        _this.filterTerm = "";
        _this.isShowingContactSelection = false;
        _this.selectedContact = null;
        _this.contactIds = [];
        _this.contacts = { status: "loading" };
        _this.renderNewProjectScreen = function () {
            var canCreate = !!_this.selectedTemplate && _this.currentCloningState === CloningState.NotCloning && !_this.isFailed;
            return (react_1.default.createElement(NewProject_1.NewProject, { templates: _this.filteredTemplates, onTemplateSelect: _this.selectTemplate, createQwilr: _this.selectContactOrCreateQwilr, onFilter: _this.filterTemplateList, onFilterClear: _this.clearFilter, filterValue: _this.filterTerm, isFailed: _this.isFailed, shouldReconnect: _this.shouldReconnect, isCreationDisabled: !canCreate }));
        };
        _this.renderContactSelection = function () {
            var canCreate = _this.currentCloningState === CloningState.NotCloning && _this.selectedContact !== null;
            return (react_1.default.createElement(ContactSelection_1.ContactSelection, { templateProjectName: _this.selectedTemplate.name, contacts: _this.contacts, onSelectContact: _this.selectContact, goBack: _this.hideContactSelection, createQwilr: _this.createQwilr, isCreationDisabled: !canCreate }));
        };
        _this.selectTemplate = function (template) {
            _this.setSelectedTemplate(template);
            _this.setIsFailed(false);
            if (_this.currentCloningState !== CloningState.IsCloning) {
                _this.setCloningState(CloningState.NotCloning);
            }
        };
        _this.shouldSelectContact = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, hubspotFields, apiService, parentId, parentType, secret, response, _b, crmObjectAssociatedContactIds, projectContainsContactTokens;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, hubspotFields = _a.hubspotFields, apiService = _a.apiService;
                        parentId = hubspotFields.parentId, parentType = hubspotFields.parentType;
                        if (parentType !== Types_1.AssociatedObjectType.Deal) {
                            return [2, false];
                        }
                        secret = this.selectedTemplate.links[0].secret;
                        return [4, apiService.fetchRelatedContactsContext(parentId, parentType, secret)];
                    case 1:
                        response = _c.sent();
                        if (!(0, HubspotNewProjectTypes_1.isErrorResponse)(response)) {
                            _b = response.data, crmObjectAssociatedContactIds = _b.crmObjectAssociatedContactIds, projectContainsContactTokens = _b.projectContainsContactTokens;
                            this.setContactIdsList(crmObjectAssociatedContactIds);
                            return [2, projectContainsContactTokens && crmObjectAssociatedContactIds.length > 0];
                        }
                        else {
                            return [2, false];
                        }
                        return [2];
                }
            });
        }); };
        _this.selectContactOrCreateQwilr = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.shouldSelectContact()];
                    case 1:
                        if (!_a.sent()) return [3, 3];
                        return [4, this.fetchContactsFromIdsList()];
                    case 2:
                        _a.sent();
                        this.setShowingContactSelection(true);
                        return [3, 4];
                    case 3:
                        this.createQwilr();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        }); };
        _this.createQwilr = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, goToProjectState, hubspotFields, apiService, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, goToProjectState = _a.goToProjectState, hubspotFields = _a.hubspotFields, apiService = _a.apiService;
                        this.setCloningState(CloningState.IsCloning);
                        return [4, apiService.sendCreateQwilrRequest(hubspotFields, this.selectedTemplate.links[0].secret, this.selectedTemplate.name, this.selectedContactId)];
                    case 1:
                        response = _b.sent();
                        if (!(0, HubspotNewProjectTypes_1.isErrorResponse)(response)) {
                            this.setCloningState(CloningState.FinishedCloning);
                            this.setIsFailed(false);
                            goToProjectState(response.data.id);
                        }
                        else {
                            this.setCloningState(CloningState.NotCloning);
                            this.setIsFailed(true);
                            if (response.err === "Could not refresh the access token") {
                                this.setShouldReconnect(true);
                            }
                        }
                        return [2];
                }
            });
        }); };
        _this.fetchContactsFromIdsList = function () { return __awaiter(_this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.apiService.fetchContactsFromIdsList(this.contactIds)];
                    case 1:
                        response = _a.sent();
                        if (!(0, HubspotNewProjectTypes_1.isErrorResponse)(response)) {
                            this.setContactsList(response.data);
                        }
                        else {
                            this.setContactsError(response.err);
                        }
                        return [2];
                }
            });
        }); };
        _this.fetchTemplates().then(function (templates) {
            if (templates !== undefined) {
                _this.setTemplateList(templates);
                _this.filterTemplateList("");
            }
            else {
                console.error("Got error when fetching templates from Qwilr");
            }
        });
        return _this;
    }
    NewProjectController.prototype.render = function () {
        if (this.isShowingContactSelection) {
            return this.renderContactSelection();
        }
        else {
            return this.renderNewProjectScreen();
        }
    };
    NewProjectController.prototype.filterTemplateList = function (filterTerm) {
        this.filterTerm = filterTerm;
        this.filteredTemplates = (0, lodash_1.filter)(this.templates, function (template) {
            return !filterTerm || template.name.match(new RegExp("\\b".concat(filterTerm), "i"));
        });
    };
    NewProjectController.prototype.clearFilter = function () {
        this.filterTemplateList("");
    };
    NewProjectController.prototype.fetchTemplates = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, hubspotFields, apiService, objectType, response;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, hubspotFields = _a.hubspotFields, apiService = _a.apiService;
                        objectType = (_b = hubspotFields.parentType) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                        if (!!!objectType) return [3, 2];
                        return [4, apiService.fetchTemplates(objectType)];
                    case 1:
                        response = _c.sent();
                        if (!(0, HubspotNewProjectTypes_1.isErrorResponse)(response)) {
                            return [2, response.data];
                        }
                        else {
                        }
                        return [3, 3];
                    case 2:
                        console.error("Hubspot object type not available, not getting templates");
                        _c.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    NewProjectController.prototype.setCloningState = function (newState) {
        this.currentCloningState = newState;
    };
    NewProjectController.prototype.setSelectedTemplate = function (template) {
        if (!!this.selectedTemplate) {
            this.selectedTemplate.selected = false;
        }
        template.selected = true;
        this.selectedTemplate = template;
    };
    NewProjectController.prototype.setIsFailed = function (isFailed) {
        this.isFailed = isFailed;
    };
    NewProjectController.prototype.setShouldReconnect = function (shouldReconnect) {
        this.shouldReconnect = shouldReconnect;
    };
    NewProjectController.prototype.setTemplateList = function (templates) {
        this.templates = templates;
    };
    NewProjectController.prototype.hideContactSelection = function () {
        if (this.selectedContact) {
            this.selectedContact.selected = false;
            this.selectedContact = null;
        }
        this.setShowingContactSelection(false);
    };
    NewProjectController.prototype.setShowingContactSelection = function (isShowing) {
        this.isShowingContactSelection = isShowing;
    };
    NewProjectController.prototype.selectContact = function (contact) {
        if (this.selectedContact) {
            this.selectedContact.selected = false;
        }
        contact.selected = true;
        this.selectedContact = contact;
    };
    NewProjectController.prototype.setContactIdsList = function (ids) {
        this.contactIds = ids;
    };
    NewProjectController.prototype.setContactsList = function (contacts) {
        this.contacts = {
            status: "ready",
            data: contacts,
        };
    };
    NewProjectController.prototype.setContactsError = function (message) {
        this.contacts = {
            status: "error",
            message: message,
        };
    };
    Object.defineProperty(NewProjectController.prototype, "selectedContactId", {
        get: function () {
            return this.selectedContact != null ? this.selectedContact.id : undefined;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], NewProjectController.prototype, "templates", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], NewProjectController.prototype, "filteredTemplates", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "selectedTemplate", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "isFailed", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "shouldReconnect", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], NewProjectController.prototype, "currentCloningState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "filterTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "isShowingContactSelection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], NewProjectController.prototype, "selectedContact", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], NewProjectController.prototype, "contactIds", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_c = typeof ContactSelectionTypes_1.Contacts !== "undefined" && ContactSelectionTypes_1.Contacts) === "function" ? _c : Object)
    ], NewProjectController.prototype, "contacts", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "filterTemplateList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "clearFilter", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setCloningState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof HubspotNewProjectTypes_1.IHubspotTemplateEntry !== "undefined" && HubspotNewProjectTypes_1.IHubspotTemplateEntry) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setSelectedTemplate", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setIsFailed", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setShouldReconnect", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setTemplateList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "hideContactSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setShowingContactSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof ContactSelectionTypes_1.Contact !== "undefined" && ContactSelectionTypes_1.Contact) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "selectContact", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setContactIdsList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setContactsList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], NewProjectController.prototype, "setContactsError", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NewProjectController.prototype, "selectedContactId", null);
    NewProjectController = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], NewProjectController);
    return NewProjectController;
}(react_1.default.Component));
exports.NewProjectController = NewProjectController;
var mountNewProject = function (mountReactComponent, apiBaseUrl, goToProjectState, fields) {
    var apiService = new NewProjectApiService_1.NewProjectApiService(apiBaseUrl);
    return mountReactComponent(react_1.default.createElement(NewProjectController, { apiService: apiService, goToProjectState: goToProjectState, hubspotFields: fields }));
};
exports.mountNewProject = mountNewProject;
